<template>
  <div class="xqNews_detail">
    <!-- 新区要闻详情 -->
    <!-- 内容区 -->
    <div class="content">
      <div class="infoCon inner">
        <!-- 面包屑导航 -->
        <div class="mbnav">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
              <img class="homeIcon" src="/statics/image/index/home.png" alt />
              首页
            </el-breadcrumb-item>
            <!-- <el-breadcrumb-item>
              <span @click="goback" v-if="catelist[nowIndex]">{{catelist[nowIndex].title}}</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{nowName}}</el-breadcrumb-item>
            </el-breadcrumb>-->
            <el-breadcrumb-item v-for="(item,index) in navList" :key="index">{{item.title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="title">
          <h3>{{articledetail.article_info?articledetail.article_info.title:""}}</h3>
          <div class="desc">
            <span>发布时间:{{articledetail.article_info?articledetail.article_info.publish_at:""}}</span>
            <span>发布人:{{articledetail.article_info?articledetail.article_info.admin.realname:""}}</span>
            <span>浏览量:{{articledetail.article_info?articledetail.article_info.hits:""}}</span>
          </div>
        </div>
        <!-- 新闻内容 -->
        <!-- <div class="newscom" v-html="articledetail.article_info.content"></div> -->
        <div class="newscom">
          <div class="fwb" v-html="content"></div>
          <a style="display:block"
            v-for="(item,index) in articledetail.article_info.funjianArr" :key="index"
            :href="$url+articledetail.article_info.funjianLinkArr[index]"
            class="fujian"
            
          >附件：{{item}}</a>
          <!-- <a
            :href="$url+articledetail.article_info.fujian"
            class="fujian"
            v-if="articledetail.article_info.fujian"
          >附件：{{articledetail.article_info.fujian_name}}</a> -->
        </div>
        <!-- 上一篇 -->
        <div class="pian">
          <div
            class="shang"
            @click="toPian(articledetail.last_article.article_id?articledetail.last_article.article_id:-1)"
          >
            上一篇：
            <span>{{articledetail.last_article.article_title?articledetail.last_article.article_title:'无'}}</span>
          </div>
          <div
            class="xia"
            @click="toPian(articledetail.next_article.article_id?articledetail.next_article.article_id:-1)"
          >
            下一篇：
            <span>{{articledetail.next_article.article_title?articledetail.next_article.article_title:'无'}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <!-- <index-footer></index-footer> -->
  </div>
</template>

<script>
// import indexTop from "./../components/top";
// import indexFooter from "./../components/footer";
export default {
  data() {
    return {
      navList: [],
      nowIndex: null,
      // nowId: null,
      // nowName: null,
      catelist: [],
      content: "", //富文本
      articledetail: {
        article_info: {
          title: "",
          publish_at: "",
          admin: {}
        },
        last_article: {}, //上一篇
        next_article: {} //下一篇
      }
    };
  },
  created() {
    this.getArticledetail();
    this.getNav();
  },
  // components: {
  //   indexTop,
  //   indexFooter
  // },
  methods: {
    getfu(str){
      var res = str.split(',');
      var fu =[];
      for(var i in res){
        fu.push(res[i])
      }
      // this.fuList = res;
    },
    goback() {
      // this.$router.go(-1);
      // this.$router.push({
      //   path: "xqNews",
      //   query: {
      //     id: this.catelist[this.nowIndex].id,
      //     index: this.nowIndex
      //   }
      // });
    },
    getNav() {
      var that = this;
      that.nowIndex = that.$route.query.index;
      // that.nowId = that.$route.query.erId;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          that.catelist = res.result.all_cate;

          // var s_cates = that.catelist[that.nowIndex].s_cates;
          // for (var i in s_cates) {
          //   if (s_cates[i].id == that.nowId) {
          //     that.nowName = s_cates[i].title;
          //   }
          // }
        }
      });
    },
    getArticledetail() {
      var that = this;
      var ps = {
        cate_id:that.$route.query.cate_id,
        article_id: that.$route.query.id
      };
      // that.$api.index.articledetail(ps).then(function(res) {
      that.$api.index.leadarticledetail(ps).then(function(res) {
        if (res.code == 200) {
          that.articledetail = res.result;
          that.navList = res.result.catelist;
          var fujinNames = res.result.article_info.fujian_name
        //   fujinNames = fujinNames.substring(0, fujinNames.lastIndexOf(','))
		  console.log('fujinNames',fujinNames)
          var funjianLinks = res.result.article_info.fujian
          var funjianArr = []
          var funjianLinkArr = []
          if (fujinNames && fujinNames != undefined && fujinNames !='') {
            funjianArr = fujinNames.split(',').filter(item=> item!="" );
            funjianLinkArr = funjianLinks.split(',').filter(item=> item!="");
            for (let i = 0; i < funjianLinkArr.length; i++) {
              const fujian = funjianLinkArr[i];
              // console.log(fujian)
              if (fujian.indexOf('upload') < 0) {
                funjianLinkArr[i] = '/upload/'+fujian
              }
              // console.log(fujian)
            } 
            // console.log(funjianLinkArr)
          }
          that.articledetail.article_info.funjianArr = funjianArr
          that.articledetail.article_info.funjianLinkArr = funjianLinkArr
          if (res.result.article_info && res.result.article_info.content) {
            that.content = res.result.article_info.content.replace(
              /\ src\=\"\upload/g,
              ' class="fupic" src="' + that.$url + "/upload"
            );
          }else{
			  that.content = "";
		  }
        }
      });
    },
    // 点击上下篇
    toPian(id) {
      if (id != -1) {
        this.$router.push({
          path: "/leaderInfo_detail",
          query: {
            cate_id:this.$route.query.cate_id,
            id: id,
            index: this.$route.query.index
          }
        });
      }
    }
  },
  mounted() {},
  watch: {
    $route(to, from) {
      this.getArticledetail();
    }
  }
};
</script>

<style>
</style>